var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 39,
    viewBox: "0 0 51 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 77324"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 907",
    cx: 1.44532,
    cy: 1.25526,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 921",
    cx: 1.44532,
    cy: 4.96406,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 935",
    cx: 1.44532,
    cy: 8.67286,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 949",
    cx: 1.44532,
    cy: 12.3826,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 963",
    cx: 1.44532,
    cy: 16.0914,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 977",
    cx: 1.44532,
    cy: 19.8003,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 991",
    cx: 1.44532,
    cy: 23.51,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1005",
    cx: 1.44532,
    cy: 27.2189,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1019",
    cx: 1.44532,
    cy: 30.9277,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1033",
    cx: 1.44532,
    cy: 34.6365,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1047",
    cx: 1.44532,
    cy: 38.3463,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 908",
    cx: 5.15431,
    cy: 1.25526,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 922",
    cx: 5.15431,
    cy: 4.96406,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 936",
    cx: 5.15431,
    cy: 8.67286,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 950",
    cx: 5.15431,
    cy: 12.3826,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 964",
    cx: 5.15431,
    cy: 16.0914,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 978",
    cx: 5.15431,
    cy: 19.8003,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 992",
    cx: 5.15431,
    cy: 23.51,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1006",
    cx: 5.15431,
    cy: 27.2189,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1020",
    cx: 5.15431,
    cy: 30.9277,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1034",
    cx: 5.15431,
    cy: 34.6365,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1048",
    cx: 5.15431,
    cy: 38.3463,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 909",
    cx: 8.86427,
    cy: 1.25526,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 923",
    cx: 8.86427,
    cy: 4.96406,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 937",
    cx: 8.86427,
    cy: 8.67286,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 951",
    cx: 8.86427,
    cy: 12.3826,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 965",
    cx: 8.86427,
    cy: 16.0914,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 979",
    cx: 8.86427,
    cy: 19.8003,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 993",
    cx: 8.86427,
    cy: 23.51,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1007",
    cx: 8.86427,
    cy: 27.2189,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1021",
    cx: 8.86427,
    cy: 30.9277,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1035",
    cx: 8.86427,
    cy: 34.6365,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1049",
    cx: 8.86427,
    cy: 38.3463,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 910",
    cx: 12.5723,
    cy: 1.25526,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 924",
    cx: 12.5723,
    cy: 4.96406,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 938",
    cx: 12.5723,
    cy: 8.67286,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 952",
    cx: 12.5723,
    cy: 12.3826,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 966",
    cx: 12.5723,
    cy: 16.0914,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 980",
    cx: 12.5723,
    cy: 19.8003,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 994",
    cx: 12.5723,
    cy: 23.51,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1008",
    cx: 12.5723,
    cy: 27.2189,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1022",
    cx: 12.5723,
    cy: 30.9277,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1036",
    cx: 12.5723,
    cy: 34.6365,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1050",
    cx: 12.5723,
    cy: 38.3463,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 911",
    cx: 16.2822,
    cy: 1.25526,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 925",
    cx: 16.2822,
    cy: 4.96406,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 939",
    cx: 16.2822,
    cy: 8.67286,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 953",
    cx: 16.2822,
    cy: 12.3826,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 967",
    cx: 16.2822,
    cy: 16.0914,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 981",
    cx: 16.2822,
    cy: 19.8003,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 995",
    cx: 16.2822,
    cy: 23.51,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1009",
    cx: 16.2822,
    cy: 27.2189,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1023",
    cx: 16.2822,
    cy: 30.9277,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1037",
    cx: 16.2822,
    cy: 34.6365,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1051",
    cx: 16.2822,
    cy: 38.3463,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 912",
    cx: 19.9912,
    cy: 1.25526,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 926",
    cx: 19.9912,
    cy: 4.96406,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 940",
    cx: 19.9912,
    cy: 8.67286,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 954",
    cx: 19.9912,
    cy: 12.3826,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 968",
    cx: 19.9912,
    cy: 16.0914,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 982",
    cx: 19.9912,
    cy: 19.8003,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 996",
    cx: 19.9912,
    cy: 23.51,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1010",
    cx: 19.9912,
    cy: 27.2189,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1024",
    cx: 19.9912,
    cy: 30.9277,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1038",
    cx: 19.9912,
    cy: 34.6365,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1052",
    cx: 19.9912,
    cy: 38.3463,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 913",
    cx: 23.7002,
    cy: 1.25526,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 927",
    cx: 23.7002,
    cy: 4.96406,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 941",
    cx: 23.7002,
    cy: 8.67286,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 955",
    cx: 23.7002,
    cy: 12.3826,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 969",
    cx: 23.7002,
    cy: 16.0914,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 983",
    cx: 23.7002,
    cy: 19.8003,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 997",
    cx: 23.7002,
    cy: 23.51,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1011",
    cx: 23.7002,
    cy: 27.2189,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1025",
    cx: 23.7002,
    cy: 30.9277,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1039",
    cx: 23.7002,
    cy: 34.6365,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1053",
    cx: 23.7002,
    cy: 38.3463,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 914",
    cx: 27.4092,
    cy: 1.25526,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 928",
    cx: 27.4092,
    cy: 4.96406,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 942",
    cx: 27.4092,
    cy: 8.67286,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 956",
    cx: 27.4092,
    cy: 12.3826,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 970",
    cx: 27.4092,
    cy: 16.0914,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 984",
    cx: 27.4092,
    cy: 19.8003,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 998",
    cx: 27.4092,
    cy: 23.51,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1012",
    cx: 27.4092,
    cy: 27.2189,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1026",
    cx: 27.4092,
    cy: 30.9277,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1040",
    cx: 27.4092,
    cy: 34.6365,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1054",
    cx: 27.4092,
    cy: 38.3463,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 915",
    cx: 31.1182,
    cy: 1.25526,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 929",
    cx: 31.1182,
    cy: 4.96406,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 943",
    cx: 31.1182,
    cy: 8.67286,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 957",
    cx: 31.1182,
    cy: 12.3826,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 971",
    cx: 31.1182,
    cy: 16.0914,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 985",
    cx: 31.1182,
    cy: 19.8003,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 999",
    cx: 31.1182,
    cy: 23.51,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1013",
    cx: 31.1182,
    cy: 27.2189,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1027",
    cx: 31.1182,
    cy: 30.9277,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1041",
    cx: 31.1182,
    cy: 34.6365,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1055",
    cx: 31.1182,
    cy: 38.3463,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 916",
    cx: 34.8262,
    cy: 1.25526,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 930",
    cx: 34.8262,
    cy: 4.96406,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 944",
    cx: 34.8262,
    cy: 8.67286,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 958",
    cx: 34.8262,
    cy: 12.3826,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 972",
    cx: 34.8262,
    cy: 16.0914,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 986",
    cx: 34.8262,
    cy: 19.8003,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1000",
    cx: 34.8262,
    cy: 23.51,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1014",
    cx: 34.8262,
    cy: 27.2189,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1028",
    cx: 34.8262,
    cy: 30.9277,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1042",
    cx: 34.8262,
    cy: 34.6365,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1056",
    cx: 34.8262,
    cy: 38.3463,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 917",
    cx: 38.5361,
    cy: 1.25526,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 931",
    cx: 38.5361,
    cy: 4.96406,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 945",
    cx: 38.5361,
    cy: 8.67286,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 959",
    cx: 38.5361,
    cy: 12.3826,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 973",
    cx: 38.5361,
    cy: 16.0914,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 987",
    cx: 38.5361,
    cy: 19.8003,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1001",
    cx: 38.5361,
    cy: 23.51,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1015",
    cx: 38.5361,
    cy: 27.2189,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1029",
    cx: 38.5361,
    cy: 30.9277,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1043",
    cx: 38.5361,
    cy: 34.6365,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1057",
    cx: 38.5361,
    cy: 38.3463,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 918",
    cx: 42.2451,
    cy: 1.25526,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 932",
    cx: 42.2451,
    cy: 4.96406,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 946",
    cx: 42.2451,
    cy: 8.67286,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 960",
    cx: 42.2451,
    cy: 12.3826,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 974",
    cx: 42.2451,
    cy: 16.0914,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 988",
    cx: 42.2451,
    cy: 19.8003,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1002",
    cx: 42.2451,
    cy: 23.51,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1016",
    cx: 42.2451,
    cy: 27.2189,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1030",
    cx: 42.2451,
    cy: 30.9277,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1044",
    cx: 42.2451,
    cy: 34.6365,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1058",
    cx: 42.2451,
    cy: 38.3463,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 919",
    cx: 45.9541,
    cy: 1.25526,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 933",
    cx: 45.9541,
    cy: 4.96406,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 947",
    cx: 45.9541,
    cy: 8.67286,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 961",
    cx: 45.9541,
    cy: 12.3826,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 975",
    cx: 45.9541,
    cy: 16.0914,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 989",
    cx: 45.9541,
    cy: 19.8003,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1003",
    cx: 45.9541,
    cy: 23.51,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1017",
    cx: 45.9541,
    cy: 27.2189,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1031",
    cx: 45.9541,
    cy: 30.9277,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1045",
    cx: 45.9541,
    cy: 34.6365,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1059",
    cx: 45.9541,
    cy: 38.3463,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 920",
    cx: 49.6631,
    cy: 1.25526,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 934",
    cx: 49.6631,
    cy: 4.96406,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 948",
    cx: 49.6631,
    cy: 8.67286,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 962",
    cx: 49.6631,
    cy: 12.3826,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 976",
    cx: 49.6631,
    cy: 16.0914,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 990",
    cx: 49.6631,
    cy: 19.8003,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1004",
    cx: 49.6631,
    cy: 23.51,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1018",
    cx: 49.6631,
    cy: 27.2189,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1032",
    cx: 49.6631,
    cy: 30.9277,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1046",
    cx: 49.6631,
    cy: 34.6365,
    r: 0.618174,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1060",
    cx: 49.6631,
    cy: 38.3463,
    r: 0.618174,
    fill: "#BFBFBF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckered);
export default __webpack_public_path__ + "static/media/Checkered.8dfcbc54e0aac669d0c1030d8cc024d6.svg";
export { ForwardRef as ReactComponent };